var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2063 0.379355L8.31351 0.375854C5.50826 0.375854 3.69614 2.23435 3.69614 5.11398V7.2971H0.793762V11.2477H3.69614L3.69264 19.6259H7.75351L7.75701 11.2477H11.0873L11.0846 7.29798H7.75701V5.4456C7.75701 4.55485 7.96789 4.10423 9.12726 4.10423L11.1975 4.10335L11.2063 0.379355Z",
    fill: "#4064AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.583bc5128e7789bc7659a52f76fb748c.svg";
export { ForwardRef as ReactComponent };